import React, { forwardRef, RefCallback } from 'react';
import { InputMaskElement } from "imask/controls/input";
import { IMaskInput } from "react-imask";

type Props = {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
};

const IdentifierInputField = forwardRef<InputMaskElement, Props>(
    (props, inputRef) => {
        const { onChange, ...other } = props;

        return (
            <IMaskInput
                id="identifierInput"
                inputRef={inputRef as RefCallback<InputMaskElement>}
                mask="regex"
                blocks={{
                    regex: /^[^\r\n]*$/
                }}
                unmask={false}
                onAccept={(value) => {
                    if (typeof value === 'string') {
                        onChange({
                            target: { name: other.name, value: value.trim() },
                        });
                    }
                }}
            />
        );
});
export default IdentifierInputField;
